import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FlashSvg = function FlashSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.187 2h9.772L15.83 7.555H22L9.067 22H5.2l4.128-7.407H2zm.808 1.481-6.261 9.63h7.12L7.726 20.52h.675L18.682 9.036h-5.8l4.127-5.555z",
    clipRule: "evenodd"
  }));
};
export var Flash = function Flash(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FlashSvg
  }));
};